import React from 'react'


export default function LandBot() {
    return (
        <script src="https://static.landbot.io/landbot-widget/landbot-widget-1.0.0.js"></script>
    )
}
